import React from 'react';
import { CircularProgress } from '@mui/material';

const Loader = () => {
  return (
    <div className="flex items-center justify-center h-full w-full p-4">
      <CircularProgress />
    </div>
  );
};

export default Loader;
